import { TuiNavigation } from '@taiga-ui/layout';

import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { Store } from '@ngxs/store';
import { TuiButton } from '@taiga-ui/core';

import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthState } from '@store/auth/auth.state';
import { FormsModule } from '@angular/forms';

import { PermissionService } from '@shared/services/permission.service';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { MENU_ITEMS } from './menu';
import { RouteNames } from '../../route-names';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.less',
  imports: [TuiButton, RouterLink, UserMenuComponent, FormsModule, TuiNavigation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  protected readonly LOGIN_PAGE = RouteNames.LOGIN_PAGE;

  isAuthenticated = this.store.selectSignal(AuthState.isAuthenticated);

  user = this.store.selectSignal(AuthState.getUserPersonalData);
  availableMenuItems = computed(() => {
    this.user()?.email ?? '';
    return MENU_ITEMS.filter(menuItem => {
      if (menuItem?.authenticated) {
        return (
          this.isAuthenticated() &&
          (menuItem.permission
            ? this.permissionService.hasAuthority(menuItem.permission)
            : true)
        );
      }
      return true;
    });
  });

  protected readonly MAIN_PAGE = RouteNames.MAIN_PAGE;

  protected readonly RouteNames = RouteNames;
  constructor(
    private readonly store: Store,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly permissionService: PermissionService,
  ) {}

  navigate(item: { path: string }) {
    this.router.navigate([item.path]);
  }
}
